/**
 * @generated SignedSource<<f281f5a6e6dc20628a1f3f40dbf64b09>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAddToCartButton_item$data = {
  readonly lastActiveTransaction: {
    readonly checkoutDate: string | null;
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useAddItemToCart_item">;
  readonly " $fragmentType": "PdpSharedAddToCartButton_item";
};
export type PdpSharedAddToCartButton_item$key = {
  readonly " $data"?: PdpSharedAddToCartButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAddToCartButton_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useAddItemToCart_item"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "concreteType": "Transaction",
      "kind": "LinkedField",
      "name": "lastActiveTransaction",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkoutDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "febd2fa2716233e8102d9fbabbd8006f";

export default node;
